import { DataCard } from "components/common/DataCard";
import {
  CRH_CHOICES_HEADING,
  ONE_CHOICE_TITLE,
  CHOICES_TITLE,
  CRH_CHOICE_TEXT,
  CRH_CHOICES_TEXT1,
  CRH_CHOICES_TEXT2,
  CHOICES_NOTE,
} from "./RequestRepaymentHoliday.const";

interface CRHChoicesExplainedProps {
  showSingleOption?: boolean;
}

export const CRHChoicesExplained = ({
  showSingleOption = false,
}: CRHChoicesExplainedProps) => {
  // Show single option version
  if (showSingleOption) {
    return (
      <DataCard>
        <div className="choices-explained">
          <div className="zb-heading4 card-sub-heading">
            {CRH_CHOICES_HEADING}
          </div>
          <div>
            <strong>{ONE_CHOICE_TITLE}</strong>
          </div>
          <ul>
            <li>
              <span>{CRH_CHOICE_TEXT}</span>
            </li>
          </ul>
        </div>
      </DataCard>
    );
  }

  // Show two options version (default)
  return (
    <DataCard>
      <div className="choices-explained">
        <div className="zb-heading4 card-sub-heading">
          {CRH_CHOICES_HEADING}
        </div>
        <div>
          <strong>{CHOICES_TITLE}</strong>
        </div>
        <ul>
          <li>
            <span>{CRH_CHOICES_TEXT1}</span>
          </li>
          <li>
            <span>{CRH_CHOICES_TEXT2}</span>
          </li>
        </ul>
        <div className="selected-options-note">
          <strong>{CHOICES_NOTE}</strong>
        </div>
      </div>
    </DataCard>
  );
};
